const loadButtons = document.querySelectorAll(
    '.js-lightbox-video .js-media-gallery-load'
);

const loadMore = (e) => {
    //cache DOM elements
    const _this = e.target;
    const blockParent = e.target.closest('.js-lightbox-video');
    const gridContainer = blockParent.querySelector('.bmg-posts .row');
    const slider = blockParent.querySelector('.gallery-slider__slider-fluid');

    // add loading state
    blockParent.classList.add('ajax-loading');

    // get and increase page number and update button attribute
    const paged = parseInt(_this.getAttribute('data-paged')) + 1;
    _this.setAttribute('data-paged', paged);

    // get max page query attribute
    const maxPage = parseInt(_this.getAttribute('data-max-paged'));

    fetch(WP.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },
        body: new URLSearchParams({
            action: 'media_gallery_load',
            paged: paged,
            ppp: _this.getAttribute('data-ppp'),
        }),
    })
        .then((response) => response.json())
        .then((response) => {
            // update posts in grid
            gridContainer.insertAdjacentHTML('beforeend', response.posts);

            // update ligthbox
            slider && jQuery(slider).slick('slickAdd', response.posts_lightbox);

            //remove loading state
            blockParent.classList.remove('ajax-loading');

            //hide button if max page is reached
            if (paged >= maxPage) {
                _this.classList.add('hide');
            }
        })
        .catch((error) => {
            console.log(error);
            blockParent.classList.remove('ajax-loading');
        });
};

loadButtons.forEach((el) => el.addEventListener('click', loadMore));
